import { domStorage } from '../_globals'
import gsap from 'gsap'

export default class NeedHelp {
  constructor() {
    if (!domStorage.needHelp) return

    // DOM
    this.DOM = {
      toggleButtonMobile: domStorage.needHelp.querySelector('button.toggle-mobile'),
      closeButtonDesktop: domStorage.needHelp.querySelector('button.close-popup-desktop'),
    }

    // Settings
    this.bodyClassName = '--show-need-help'
    this.bodyClassNameMobile = '--show-need-help-mobile'

    // Events
    this.toggleMobile = this.toggleMobile.bind(this)
    this.close = this.close.bind(this)

    this.DOM.toggleButtonMobile && this.DOM.toggleButtonMobile.addEventListener('click', this.toggleMobile)
    this.DOM.closeButtonDesktop & this.DOM.closeButtonDesktop.addEventListener('click', this.close)

    // DÉDUCTIONS (29/07, retour Sandro — la maquette de Marine ne montre ni le
    // bandeau d'avis eKomi ni l'état bas de page des boutons flottants).
    // Trois règles, posées en classes body au scroll, lues aussi par
    // scroll-cta.js et _scroll-cta.scss. À confirmer par Marine :
    //   --cta-premier-ecran : pas de bouton flottant sur le premier écran
    //     (consigne déjà actée par Amélie pour le (+) de la home, étendue au
    //     NeedHelp mobile qui occupe le même coin) ;
    //   --avis-fixe : le bandeau d'avis eKomi (#pos-bottom_left, injecté en
    //     fixed pleine largeur, 60px) est affiché -> les boutons REMONTENT
    //     au-dessus de lui au lieu de le chevaucher ;
    //   --cta-fin-de-page : la zone du coin entre en collision avec un bloc
    //     du FLUX (footer…) -> les boutons s'effacent en fondu et ne
    //     recouvrent jamais ce contenu. Les éléments fixed sont exclus du
    //     calcul (le bandeau, permanent, la déclencherait en continu).
    this.proteges = [...document.querySelectorAll('.Footer, footer, .ekomi-widget-container')]
    this.etatFlottants = { premier: null, avis: null, fin: null }
    this.ticking = false
    this.onScroll = this.onScroll.bind(this)
    this.updateFlottants = this.updateFlottants.bind(this)
    window.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('resize', this.onScroll, { passive: true })
    this.updateFlottants()
    // le widget eKomi s'injecte bien après le load : on re-regarde sans scroll
    this.timerAvis = setTimeout(this.updateFlottants, 6000)
  }

  onScroll() {
    if (this.ticking) return
    this.ticking = true
    window.requestAnimationFrame(this.updateFlottants)
  }

  updateFlottants() {
    this.ticking = false

    const premier = window.scrollY < window.innerHeight
    const bandeau = document.querySelector('#pos-bottom_left, .ekw150')
    const avis = !!bandeau && bandeau.getBoundingClientRect().height > 0
    // zone du coin la plus haute des deux configurations (bouton remonté ou non)
    const hautZone = window.innerHeight - 160
    const fin = this.proteges.some((el) => {
      if (getComputedStyle(el).position === 'fixed') return false
      const r = el.getBoundingClientRect()
      return r.height > 0 && r.top < window.innerHeight && r.bottom > hautZone
    })

    const e = this.etatFlottants
    if (premier !== e.premier) { e.premier = premier; domStorage.body.classList.toggle('--cta-premier-ecran', premier) }
    if (avis !== e.avis) { e.avis = avis; domStorage.body.classList.toggle('--avis-fixe', avis) }
    if (fin !== e.fin) { e.fin = fin; domStorage.body.classList.toggle('--cta-fin-de-page', fin) }
  }

  toggleMobile(e) {
    e && e.preventDefault()

    domStorage.body.classList.toggle(this.bodyClassNameMobile)
  }

  open(e) {
    e && e.preventDefault()

    domStorage.body.classList.add(this.bodyClassName)
  }

  close(e) {
    e && e.preventDefault()

    domStorage.body.classList.remove(this.bodyClassName)
  }

  destroy() {
    this.DOM.toggleButtonMobile && this.DOM.toggleButtonMobile.removeEventListener('click', this.toggleMobile)
    this.DOM.toggleButtonMobile && this.DOM.closeButton.removeEventListener('click', this.close)
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onScroll)
    clearTimeout(this.timerAvis)
    domStorage.body.classList.remove('--cta-premier-ecran', '--avis-fixe', '--cta-fin-de-page')
  }
}
